import { render, staticRenderFns } from "./ServicesReservationsCalendar.vue?vue&type=template&id=e4155ec6&"
import script from "./ServicesReservationsCalendar.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationsCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports